import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDropdownSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M7.21365 10.6758C7.62699 11.1081 8.37301 11.1081 8.78635 10.6758L12.7487 6.53243C13.3245 5.93027 12.8472 5 11.9623 5H4.03769C3.15285 5 2.67549 5.93027 3.25134 6.53243L7.21365 10.6758Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
